/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Externaltempdefect2Inputs */



/**
* | output |
* | --- |
* | "External temperature sensor defect" |
*
* @param {Br_History_Key_Externaltempdefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_externaltempdefect2 = /** @type {((inputs?: Br_History_Key_Externaltempdefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Externaltempdefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("External temperature sensor defect")
	return /** @type {LocalizedString} */ ("Défaut de la sonde de température extérieure")
});
export { br_history_key_externaltempdefect2 as "br_history_key_externalTempDefect" }